<template>
  <div class="bb-doc-location" :class="{'bb-doc-location_office': locationOffice}">
    <i class="bb-doc-location__icon icon-toggle-office" v-if="locationOffice"/>
    <i class="bb-doc-location__icon bb-doc-location__icon_client icon-toggle-client" v-else/>
  </div>
</template>

<script>
import {docLocation} from '@/constants/documentTags'

export default {
  name: 'DocumentLocation',
  props: ['value'],
  computed: {
    locationOffice () {
      return this.value === docLocation.office
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../../../../../sass/variables";

  .bb-doc-location {
    display: flex;
    align-items: center;
    justify-content: start;
    width: 32px;
    height: 17px;
    background: $color-accent;
    border-radius: 73px;
    padding: 3px;

    &_office {
      background-color: $color-jaffa;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 11px;
      color: $color-white;
      width: 11px;
      height: 11px;
      margin-right: auto;
      margin-left: 0;

      &_client {
        margin-right: 0;
        margin-left: auto;
      }

      &:before {
        margin: 0;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactDocuments/DocumentLocation/DocumentLocation.vue